//Styles
import myStyles from "../../../../../styles/referrals/ReferralEntityFormChangeLog.module.css"
import { getLocalDateTimeFromIso } from "../../../../Referrals/Components/sharedFunctions"

export default function ReferralEntityChangeLogItem({ logEntry }) {
  const dateValue = getLocalDateTimeFromIso(logEntry.changeDate)

  const GetType = ({ type }) => {
    let color = "black"

    switch (type) {
      case "Added":
        color = "green"
        break
      case "Modified":
        color = "orange"
        break
      case "Deleted":
        color = "red"
        break
      default:
        break
    }

    return <span style={{ color: color }}>{type}</span>
  }

  return (
    <div className={myStyles.logItemGridContainer}>
      {!!logEntry.locationName ? (
        <div className={myStyles.logItemLocation}>
          <span className={myStyles.fieldTitle}>Location: </span>
          {logEntry.locationName}
        </div>
      ) : null}
      {!!logEntry.locationServiceCategoryName ? (
        <div className={myStyles.logItemLocationCategory}>
          <span className={myStyles.fieldTitle}>Service category: </span>
          {logEntry.locationServiceCategoryName}
        </div>
      ) : null}
      <div className={myStyles.logItemStaff}>
        <span className={myStyles.fieldTitle}>Staff: </span>
        <GetType type={logEntry.userName} />
      </div>

      <div className={myStyles.logItemOrganization}>
        <span className={myStyles.fieldTitle}>Organization: </span>
        <GetType type={logEntry.organizationName} />
      </div>
      <div className={myStyles.logItemCategory}>
        <span className={myStyles.fieldTitle}>Category: </span>
        {logEntry.category}
      </div>

      <div className={myStyles.logItemType}>
        <span className={myStyles.fieldTitle}>Type: </span>
        <GetType type={logEntry.type} />
      </div>
      <div className={myStyles.logItemDate}>
        <span className={myStyles.fieldTitle}>Date: </span>
        {dateValue}
      </div>
      {logEntry.type !== "Added" ||
      !!logEntry.oldValue ||
      !!logEntry.newValue ? (
        <>
          <div className={myStyles.logItemField}>
            <span className={myStyles.fieldTitle}>Field: </span>
            {logEntry.field}
          </div>
          <div className={myStyles.logItemOldValue}>
            <span className={myStyles.fieldTitle}>Old value: </span>
            {logEntry.oldValue}
          </div>
          <div className={myStyles.logItemNewValue}>
            <span className={myStyles.fieldTitle}>New value: </span>
            {logEntry.newValue}
          </div>
        </>
      ) : null}
    </div>
  )
}
